import * as R from 'ramda';
export var STRUCTURE_ATTRIBUTE_LIST_PATH = ['data', 'dataStructures', 0, 'dataStructureComponents', 'attributeList'];
export var STRUCTURE_ATTRIBUTES_PATH = R.append('attributes', STRUCTURE_ATTRIBUTE_LIST_PATH);